module.exports = __webpack_public_path__ + "img/image_circleword.26c60f90.svg";